import { gql, useQuery } from '@apollo/client';
import {
  BookingFilterOptions,
  BookingFilterOptionsVariables,
} from './__generated__/BookingFilterOptions';

export const BOOKING_FILTER_OPTIONS = gql`
  query BookingFilterOptions($serviceId: ID!) {
    bookingFilterOptions(input: { serviceId: $serviceId }) {
      expertises {
        id
        name
      }
      languages {
        id
        name
        code
      }
      timeZones {
        code
        name
      }
    }
  }
`;

export const useBookingFilterOptions = (
  variables: BookingFilterOptionsVariables,
) => {
  const { data, loading, error } = useQuery<BookingFilterOptions>(
    BOOKING_FILTER_OPTIONS,
    {
      variables,
    },
  );

  return { data, loading, error };
};
